// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"481":"f315379b","559":"10a47301","615":"fe92d69a"}[chunkId] + ".chunk.css";
};